// Limpia solo los campos del formulario y los errores, sin afectar paginación ni sucursales
/**
 * Acciones para la gestión de productos - Agregar Producto (gp_ap_)
 */
import { Dispatch } from 'react'
import * as http from '../../../api/http'
import { ENDPOINTS } from '../../../api/config'
import { State } from '../../../reducers'
import {
    generalOpenModalError,
    generalOpenModalMessage,
    generalShowLoader } from '../../general.actions'
import { GESTION_PRODUCTOS_TYPES } from '../../../constants/gestionProducto.types'
import { GestionProductoAction } from '../../../interfaces/gestion-Productos.interfaces'
//import { validacionesOnBlurProducto } from '../../gestion-usuario/gu-generales/gu-generales'
import { KEYS } from '../../../constants/keysStorage'
import * as validators from '../../../utils/validaciones'
import { DICCIONARIO } from '../../../constants/Diccionario'


// ******************************************************************************************
// ? ACCIONES SIMPLES
// ******************************************************************************************


export const gp_ap_ClearFormOnly = () => ({
  type: GESTION_PRODUCTOS_TYPES.CP_FORM_CLEAR_FORM_ONLY,
  payload: null,
});

export const gp_ap_HandleChange = (formProduct: any) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_FORM_HANDLE_CHANGE,
  payload: formProduct,
})


export const gp_ap_AddError = (formError: any) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_FORM_ADD_ERROR,
  payload: formError,
})


export const gp_ap_ChangePage = (num: number) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_FORM_CHANGE_PAGE,
  payload: num,
})


export const gp_ap_Clear = () => ({
  type: GESTION_PRODUCTOS_TYPES.CP_FORM_CLEAR,
  payload: null,
})


export const gp_ap_ShowModalConfirmacion = (flag: boolean) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_SHOW_MODAL_CONFIRMACION,
  payload: flag,
})


export const gp_ap_ShowModalCreado = (flag: boolean) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_SHOW_MODAL_CREADO,
  payload: flag,
})


export const gp_ap_SetSucursales = (sucursales: Array<any>) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_SET_SUCURSALES,
  payload: sucursales,
})


export const gp_ap_SetSucursalesSeleccionadas = (sucursales: Array<string>) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_SET_SUCURSALES_ASIGNADAS,
  payload: sucursales,
})


export const gp_ap_SetIdProductoCreado = (id: any) => ({
  type: GESTION_PRODUCTOS_TYPES.CP_SET_ID_PRODUCTO_CREADO,
  payload: id,
})


// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const gp_ap_FormHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    let { name, value } = e.target


  // Validación personalizada para productos
  const mensajeError = validacionesOnBlurProducto(name, value)
  dispatch(gp_ap_AddError({ [name]: mensajeError }))
  // Siempre actualizar el valor, aunque haya error

    // Ejemplo de lógica especial para campos numéricos
    if (["precioUnitario", "precioSinIVA", "iva"].includes(name)) {
  // Permitir vacío y solo números/punto
  if (/^\d*\.?\d*$/.test(value) || value === "") {
    dispatch(gp_ap_HandleChange({ [name]: value }))
  }
  return
}


    // Ejemplo de lógica especial para mayúsculas en códigoProducto
    if (name === 'codigoProducto') {
      dispatch(gp_ap_HandleChange({ [name]: String(value).toUpperCase() }))
      return
    }

    // Por defecto, guardar el valor tal cual
    dispatch(gp_ap_HandleChange({ [name]: value }))
  }


  



// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************

export const gp_ep_EditarProducto =
  (history: any) => async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    const formProduct = getState().gestionProducto.editarProducto.formProduct

    // ========================================================================
    // Creación del body con los datos del formulario
    const body = {
      codigoProducto: formProduct.codigoProducto.trim(),
      descripcion: formProduct.descripcion.trim(),
      unidadMedida: formProduct.unidadMedida,
      precioUnitario: formProduct.precioUnitario,
      precioSinIVA: formProduct.precioSinIVA,
      iva: formProduct.iva,
      impuestoDistintoAlIVA: formProduct.impuestoDistintoAlIVA,
      //servicioProducto: formProduct.servicioProducto,
      //sucursal: formProduct.sucursal,
      codigoSucursal: formProduct.codigoSucursal,
      tipoItem: formProduct.tipoItem,

    }

    let message =
      'Existió un inconveniente al editar la información del producto, intente nuevamente'

    await http
      .post(ENDPOINTS.GESTION_PRODUCTO_UPDATE_INFO, body)
      .then(async (res: any) => {
        if (res.status === 200) {
          dispatch(
            generalOpenModalMessage(
              `Producto Actualizado`,
              `Se actualizó la información del producto`
            )
          )
          history.push('/gestion-producto/listar-producto')
          return
        }
        dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err) => {
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

// ******************************************************************************************
// ? PETICIONES RES (Agregar aquí la petición HTTP para crear productos cuando esté disponible)
// ******************************************************************************************
export const gp_ap_agregarProducto =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return;
    await dispatch(generalShowLoader(true));

    const sucursales = getState().gestionProducto.agregarProducto.sucursalesAsignadas;
    let error = false;
    let responseProducto: any = {};

    const codigoempresa = localStorage.getItem(KEYS.CODIGO_EMPRESA);
    const resEmpresa = await http.get(`${ENDPOINTS.GESTION_PRODUCTO_GET_IDEMPRESA}?codigoempresa=${codigoempresa}`);

    const idEmpresaObtenido = (resEmpresa as any)?.data?.idempresa;

    if (!idEmpresaObtenido) throw new Error("No se pudo obtener el ID de la empresa");

    const formProduct = getState().gestionProducto.agregarProducto.formProduct;
    const bodyCreacion = {
      idEmpresa: idEmpresaObtenido,
      idSucursal: sucursales.length > 0 ? sucursales[0] : null,
      clave: formProduct.codigoProducto.trim(),
      descripcion: formProduct.descripcion.trim(),
      unidad: formProduct.unidadMedida,
      tipoItem: formProduct.tipoItem,
      Impuestos: formProduct.impuestoDistintoAlIVA
  ? [Number(formProduct.impuestoDistintoAlIVA)]
  : [], // ← array vacío en lugar de null

      precioUnitarioDefault: Number(formProduct.precioUnitario),
      activo: true,
      ivaincluido: true,
      usuarioCreacion: localStorage.getItem(KEYS.USERNAME_CLIENTE) || 'desconocido',
    };
    await http
      .post(ENDPOINTS.GESTION_PRODUCTOS_SET_NEW_PRODUCTO, bodyCreacion)
      
      .then(async (res: any) => {
        if (res?.body?.idproducto) {
  responseProducto = res.body;
}

      })
      .catch(async (err) => {
        let message = "Intente nuevamente crear el producto"
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status));
        error = true;
      });

    if (error) {
      dispatch(generalShowLoader(false))
      return;
    }

    const idProducto = responseProducto?.idproducto

    if (!idProducto) {
      dispatch(generalShowLoader(false));
      return;
    }

    const bodyAsignacion = {
      idproducto: Number(idProducto),
      productoSucursal: sucursales.map((idSucursal) => ({ idsucursal: idSucursal })),
      usuarioCreacion: localStorage.getItem(KEYS.USERNAME_CLIENTE) || 'desconocido',
    };

    let msn = "El producto fue creado exitosamente,";
    let message = "Existió un inconveniente al asignar las sucursales";
    await http
    
      .post(ENDPOINTS.GESTION_PRODUCTO_POST_ASIGNAR_SUCURSALES, bodyAsignacion, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.errorCode === 0 && Array.isArray(res.body?.body?.resultados)) {
          dispatch(gp_ap_ShowModalCreado(true));
          dispatch(gp_ap_ShowModalConfirmacion(false));
        } else {
        }
      })


      .catch(async (err) => {
        await dispatch(
          generalOpenModalError(`${msn} ${err?.response?.data?.message ?? message}`, err?.response?.data?.status)
        );
      })
      .finally(() => dispatch(generalShowLoader(false)));
  };
// agregarProducto.actions.ts
export const gp_ap_ShowModalValidaciones = (activo: boolean, errores: string[] = []) => ({
  type: 'GP_AP_SHOW_MODAL_VALIDACIONES',
  payload: { activo, errores }
});

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const gp_ap_ValidacionesFormOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    let { name, value } = e.target
    let message = ''

    if (!value) message = 'Este campo es obligatorio'
    if (name === 'precio' && Number(value) < 0) message = 'El precio debe ser mayor a 0'

    dispatch(gp_ap_AddError({ [name]: message }))
  }

export const gp_ap_ValidacionesFormSiguiente =
  () => async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
  let { formProduct, formErrorProduct } = getState().gestionProducto.agregarProducto
  // Creamos un objeto de errores solo para validación, tipo string
  let errors: { [key: string]: string } = {}

  // Validaciones básicas según los campos de FormAgregarProducto
  if ('descripcion' in formProduct) {
    errors.descripcion = !formProduct.descripcion ? 'La descripción es obligatoria' : ''
  }
  if ('precioUnitario' in formProduct) {
    const precio = Number(formProduct.precioUnitario)
    errors.precioUnitario = (isNaN(precio) || precio <= 0)
      ? 'El precio es obligatorio y debe ser mayor a 0'
      : ''
  }
  dispatch(gp_ap_AddError(errors))
  if ((typeof errors.descripcion === 'string' && errors.descripcion !== '') || (typeof errors.precioUnitario === 'string' && errors.precioUnitario !== '')) return true
  return false
  }


export const gp_ap_getSucursales =
  () => async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true));

    
    const message = 'Existió un inconveniente al obtener las sucursales';

    await http
      .get(ENDPOINTS.GESTION_GET_SUCURSALES, {codigoempresa: localStorage.getItem(KEYS.CODIGO_EMPRESA)})
      .then(async (res: any) => {
        if (res.data) {
          dispatch(gp_ap_SetSucursales(res.data));
        } else {
          await dispatch(generalOpenModalError(res.message ?? message));
        }
      })
      .catch(async (err) => {
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        );
      })
      .finally(() => dispatch(generalShowLoader(false)));
  };

export const validacionesOnBlurProducto = (name: string, value: any) => {
  let message = ''
  switch (name) {
    /* case 'sucursal':
      message = validators.validacionEsRequerido(value, message)
      break */
    case 'codigoSucursal':
      message = validators.validacionEsRequerido(value, message)
      break
    case 'codigoProducto':
      message = validators.validacionEsRequerido(value, message)
      break
    case 'precioUnitario':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRECIO_UNITARIO)
      if (!message) message = validators.validacionNumMinimo(value,0)
      break
    case 'precioSinIVA':
      message = validators.validacionEsRequerido(value, message)
      if (!message) message = validators.validacionNumMinimo(value, 0)
      break
    case 'iva':
      message = validators.validacionEsRequerido(value, message)
      if (!message) message = validators.validacionNumMinimo(value, 0)
      break
    case 'tipoItem':
  message = (value == null || value === '') ? 'Este campo es obligatorio' : '';
  break

    case 'unidadMedida':
      message = validators.validacionEsRequerido(value, message)
      break
    case 'descripcion':
  message = validators.validacionEsRequerido(value, message)
  if (!message && value.length > 80) message = 'La descripción no puede exceder 80 caracteres';
  break

    /* case 'impuestoDistintoAlIVA':
      message = validators.validacionEsRequerido(value, message)
      break */
    default:
      break
  }
  return message
}

export const gp_ap_validacionesAgregarProducto =
  () => async (dispatch: Dispatch<GestionProductoAction>, getState: () => State) => {
    let { formProduct, formErrorProduct } = getState().gestionProducto.agregarProducto
    let errors = { ...formErrorProduct }

    //errors.sucursal = validacionesOnBlurProducto('sucursal', formProduct.sucursal)
    errors.codigoSucursal = validacionesOnBlurProducto('codigoSucursal', formProduct.codigoSucursal)
    errors.codigoProducto = validacionesOnBlurProducto('codigoProducto', formProduct.codigoProducto)
    errors.precioUnitario = validacionesOnBlurProducto('precioUnitario', formProduct.precioUnitario)
    errors.precioSinIVA = validacionesOnBlurProducto('precioSinIVA', formProduct.precioSinIVA)
    errors.iva = validacionesOnBlurProducto('iva', formProduct.iva)
    //errors.servicioProducto = validacionesOnBlurProducto('servicioProducto', formProduct.servicioProducto)
    errors.tipoItem = validacionesOnBlurProducto('tipoItem', formProduct.tipoItem);

    errors.unidadMedida = validacionesOnBlurProducto('unidadMedida', formProduct.unidadMedida)
    errors.descripcion = validacionesOnBlurProducto('descripcion', formProduct.descripcion)
    errors.impuestoDistintoAlIVA = validacionesOnBlurProducto('impuestoDistintoAlIVA', formProduct.impuestoDistintoAlIVA)

    dispatch(gp_ap_AddError(errors))
    if (
      //errors.sucursal ||
      errors.codigoSucursal ||
      errors.codigoProducto ||
      errors.precioUnitario ||
      errors.precioSinIVA ||
      errors.iva ||
      errors.tipoItem ||
      errors.unidadMedida ||
      errors.descripcion ||
      errors.impuestoDistintoAlIVA
    )
      return true
    return false
  }